import { IDestinationStore } from '@stores/destination';
import { ISource } from '@stores/source';
import { useState, useEffect } from 'react';
import { getFilterParams } from './utils';

export const TIME_FILTERS = [
  {
    value: 'day',
    label: 'Past 1 day',
  },
  {
    value: 'week',
    label: 'Past 7 days',
  },
  {
    value: 'month',
    label: 'Past 30 days',
  },
];

export const ALL_SOURCES = { value: 'all', label: 'All sources' };

export default (destination: IDestinationStore) => {
  const allSources = destination.sources
    .map((source: ISource) => ({ value: source.id, label: source.name }))
    .concat([ALL_SOURCES]);

  const [sourceFilter, setSourceFilter] = useState(ALL_SOURCES.value);
  const [timeFilter, setTimeFilter] = useState(TIME_FILTERS[0].value);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    onRefresh();
  }, [timeFilter, sourceFilter]);

  const onRefresh = () => {
    setLoading(true);
    destination.getEventsStats(getFilterParams(sourceFilter, timeFilter), () => setLoading(false));
  };

  const getSampleErrors = (statusCode: number) => {
    const { sourceId, start } = getFilterParams(sourceFilter, timeFilter);
    destination.getSampleErrors({ statusCode, sourceId, start });
  };

  const { eventStats, errors } = destination;

  return {
    totalDelivered:
      !eventStats?.totalDelivered && eventStats?.totalDelivered !== 0
        ? '--'
        : eventStats?.totalDelivered,
    totalFailed:
      !eventStats?.totalFailed && eventStats?.totalFailed !== 0 ? '--' : eventStats?.totalFailed,
    onRefresh,
    sourceFilter,
    setSourceFilter,
    timeFilter,
    setTimeFilter,
    errors,
    eventStats: eventStats?.graph,
    loading,
    allSources,
    getSampleErrors,
  };
};
